export const NewFeature = () => {
  return (
    <div
      style={{
        fontSize: 10,
        padding: "1px 3px",
        background: "var(--uplan-blue)",
        color: "var(--uplan-blue-text)",
        borderRadius: "6px",
      }}
    >
      New!
    </div>
  );
};
